import getComponent from '../utils/get-component'

export default getComponent('h3 flex justify-between tr-a', 'header')
